import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import { ButtonSchema } from './schema';
import { useIntl } from 'react-intl';

const ButtonBlockData = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = ButtonSchema({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default ButtonBlockData;
